<template>
  <v-card elevation="0" class="all-trade-tab rounded-0">
    <v-tabs :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-tab class="ml-0">Investor Profit Withdrawals</v-tab>
      <!-- <v-tab> Investor Profit Share </v-tab> -->
      <!-- <v-tab> Manager Commission Earning</v-tab> -->
      <v-tab-item>
        <v-card flat>
          <AllWalletTransaction></AllWalletTransaction>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <!-- <ProfitShareTab></ProfitShareTab> -->
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <!-- <ManagerCommissionTab></ManagerCommissionTab> -->
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
// import ProfitShareTab from './ProfitShareTab.vue';
import AllWalletTransaction from './AllWalletTransaction.vue';
// import AllTab from '../WalletPage/AllTab.vue';
// import ManagerCommissionTab from './ManagerCommissionTab.vue';

export default {
  name: "LiveTradeTabs",
  components: {
    AllWalletTransaction,
    // AllTab,
    // ProfitShareTab,
    // ManagerCommissionTab
  },
};
</script>
